
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 2688","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 1441","fill":"currentColor","d":"M0 0h21v20.593H0z"}})])]),_c('g',{attrs:{"data-name":"Group 2687","transform":"translate(2 2)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 2177","d":"M10.494 8.866h1.575v8.188a1.65 1.65 0 01-1.648 1.646H3.54a1.65 1.65 0 01-1.648-1.648V12.3a3.5 3.5 0 013.774-3.434V6.974A5.382 5.382 0 000 12.3v4.755a3.544 3.544 0 003.54 3.54h6.881a3.544 3.544 0 003.54-3.54V6.974h-3.467zM17.46 0h-6.881a3.544 3.544 0 00-3.54 3.54v10.08h3.466v-1.892H8.931V3.54a1.65 1.65 0 011.648-1.648h6.881a1.65 1.65 0 011.648 1.648v4.755a3.5 3.5 0 01-3.775 3.433v1.891A5.382 5.382 0 0021 8.295V3.54A3.544 3.544 0 0017.46 0","fill":"currentColor"}})]),_c('path',{attrs:{"data-name":"Path 2126","d":"M0 0h24v24H0z","fill":"none"}})])
          )
        }
      }
    